import axios from 'axios';
import config from '../config';
import { getBearerToken } from '../util/cookie';
import { notifySuccess, notifyError } from '../components/HotToast/HotToastProvider';
// import { programsSuccess } from './programs.duck';

// ================ Action types ================ //

export const ACTIVITIES_REQUEST = 'app/CoachSaaS/ACTIVITIES_REQUEST';
export const ACTIVITIES_SUCCESS = 'app/CoachSaaS/ACTIVITIES_SUCCESS';
export const ACTIVITIES_ERROR = 'app/CoachSaaS/ACTIVITIES_ERROR';

export const ACTIVITIES_SAVE_REQUEST = 'app/CoachSaaS/ACTIVITIES_SAVE_REQUEST';
export const ACTIVITIES_SAVE_SUCCESS = 'app/CoachSaaS/ACTIVITIES_SAVE_SUCCESS';
export const ACTIVITIES_SAVE_ERROR = 'app/CoachSaaS/ACTIVITIES_SAVE_ERROR';

export const EVENTS_REQUEST = 'app/CoachSaaS/EVENTS_REQUEST';
export const EVENTS_SUCCESS = 'app/CoachSaaS/EVENTS_SUCCESS';
export const EVENTS_ERROR = 'app/CoachSaaS/EVENTS_ERROR';

export const SURVEYS_REQUEST = 'app/CoachSaaS/SURVEYS_REQUEST';
export const SURVEYS_SUCCESS = 'app/CoachSaaS/SURVEYS_SUCCESS';
export const SURVEYS_ERROR = 'app/CoachSaaS/SURVEYS_ERROR';

// ================ Reducer ================ //

const initialState = {
  activities: [],
  activities_error: null,
  activities_fetching: false,

  activitiesSave: null,
  activitiesSaving: null,
  activitiesSavingError: null,

  events: null,
  eventsFetching: false,
  eventsFetchingError: null,

  surveys: [],
  surveysFetching: false,
  surveysError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case ACTIVITIES_REQUEST:
      return {
        ...state,
        activities_fetching: true,
      };
    case ACTIVITIES_SUCCESS:
      return {
        ...state,
        activities_fetching: false,
        activities: payload,
      };
    case ACTIVITIES_ERROR:
      return {
        ...state,
        activities_fetching: false,
        activities_error: payload,
      };

    case ACTIVITIES_SAVE_REQUEST:
      return {
        ...state,
        activitiesSaving: true,
      };
    case ACTIVITIES_SAVE_SUCCESS:
      return {
        ...state,
        activitiesSaving: false,
        activitiesSave: payload,
      };
    case ACTIVITIES_SAVE_ERROR:
      return {
        ...state,
        activitiesSaving: false,
        activitiesSavingError: payload,
      };

    case EVENTS_REQUEST:
      return {
        ...state,
        eventsFetching: true,
      };
    case EVENTS_SUCCESS:
      return {
        ...state,
        eventsFetching: false,
        events: payload,
      };
    case EVENTS_ERROR:
      return {
        ...state,
        eventsFetching: false,
        eventsFetchingError: payload,
      };

    case SURVEYS_REQUEST:
      return {
        ...state,
        surveysFetching: true,
      };
    case SURVEYS_SUCCESS:
      return {
        ...state,
        surveysFetching: false,
        surveys: payload,
      };
    case SURVEYS_ERROR:
      return {
        ...state,
        surveysFetching: false,
        surveysError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const activitiesRequest = () => ({ type: ACTIVITIES_REQUEST });
export const activitiesSuccess = data => ({ type: ACTIVITIES_SUCCESS, payload: data });
export const activitiesError = error => ({ type: ACTIVITIES_ERROR, payload: error });

export const activitiesSaveRequest = () => ({ type: ACTIVITIES_SAVE_REQUEST });
export const activitiesSaveSuccess = data => ({ type: EVENTS_SUCCESS, payload: data });
export const activitiesSaveError = error => ({ type: ACTIVITIES_SAVE_ERROR, payload: error });

export const eventsRequest = () => ({ type: EVENTS_REQUEST });
export const eventsSuccess = data => ({ type: EVENTS_SUCCESS, payload: data });
export const eventsError = error => ({ type: EVENTS_ERROR, payload: error });

export const surveysRequest = () => ({ type: SURVEYS_REQUEST });
export const surveysSuccess = data => ({ type: SURVEYS_SUCCESS, payload: data });
export const surveysError = error => ({ type: SURVEYS_ERROR, payload: error });

// ================ Thunks ================ //

export const getAllActivities = (completedOnly, docId, goTo) => async (dispatch, getState, sdk) => {
  dispatch(activitiesRequest());

  const compOnly = completedOnly ? 'yes' : 'no';

  axios
    .get(`${config.coachSaaSService}activities`, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
        docId: docId,
        goTo: goTo,
        completedOnly: compOnly,
      },
    })
    .then(res => {
      dispatch(activitiesSuccess(res.data));
      // if(res.data.length > 0){
      //   dispatch(activitiesSuccess(res.data));
      // }
      //
      // dispatch(activitiesSuccess(getState().activities.activities));
    })
    .catch(err => {
      console.log(err);
      dispatch(activitiesError(err));
    });
};

export const getClientActivity = id => async (dispatch, getState, sdk) => {
  return axios.get(`${config.coachSaaSService}activities/${id}`, {
    headers: {
      'content-type': 'application/json',
      Authorization: await getBearerToken(sdk),
    },
  });
};

// Pull the program's current sessions into an existing client activity.
// Used to recover activities that were created before the program had its
// sessions (the activity stores a one-time snapshot). Append-only on the
// backend — already-scheduled sessions are preserved.
export const syncActivitySessions = activityId => async (dispatch, getState, sdk) => {
  return axios.post(
    `${config.coachSaaSService}activities/${activityId}/sync_sessions`,
    {},
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

// Coach drags a client's sessions into a new order. orderedSessions is an
// array of session ids in the desired display order — the backend rewrites
// each session's orderIndex to match and the participant's "My activity"
// page (fetching the same underlying activity doc) picks up the new order
// on its next load, no separate sync needed.
export const reorderActivitySessions = (activityId, orderedSessions) => async (
  dispatch,
  getState,
  sdk
) => {
  return axios.post(
    `${config.coachSaaSService}activities/${activityId}/sessions/reorder`,
    { orderedSessions },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

export const addClientActivity = transactionId => async (dispatch, getState, sdk) => {
  dispatch(activitiesSaveRequest());
  const params = {
    transactionId: transactionId,
  };

  const url = `${config.coachSaaSService}activities`;
  return axios
    .post(url, params, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    })
    .then(res => {
      dispatch(activitiesSaveSuccess(res.data));
    })
    .catch(err => {
      console.log(err);
      dispatch(activitiesSaveError(err));
    });
};

// export const planClientSession = (activityId, sessId, data) => async (dispatch, getState, sdk) => {
//   return axios
//     .post(
//       `${config.coachSaaSService}activities/${activityId}/session/${sessId}/plan`,
//       { date: data },
//       {
//         headers: {
//           'content-type': 'application/json',
//           Authorization: await getBearerToken(sdk),
//         },
//       }
//     )
//     .then(res => {})
//     .catch(err => {
//       console.log(err);
//     });
// };

// Coach designates which session the participant should start with (the
// "★ Start here" session). Pass clear=true to remove the designation.
// Exactly one session per activity is the start point — the backend clears
// the flag from every other session.
export const setSessionStartHere = (activityId, sessId, clear = false) => async (
  dispatch,
  getState,
  sdk
) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/start-here`,
      { clear },
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      notifySuccess(clear ? 'Start session cleared' : 'Start session set');
      return res;
    })
    .catch(err => {
      console.log(err);
      notifyError('Could not update the start session — please try again');
      throw err;
    });
};

export const makeSessionOngoing = (activityId, sessId, time) => async (dispatch, getState, sdk) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/ongoing`,
      { time: time },
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      notifySuccess('Session started');
    })
    .catch(err => {
      console.log(err);
      notifyError('Failed to start session');
    });
};

export const pauseSession = (activityId, sessId, elapsedTime) => async (
  dispatch,
  getState,
  sdk
) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/pause`,
      { elapsedTime },
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      notifySuccess('Session paused');
    })
    .catch(err => {
      console.log(err);
      notifyError('Failed to pause session');
    });
};

export const resumeSession = (activityId, sessId, resumedAt) => async (dispatch, getState, sdk) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/resume`,
      { resumedAt },
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      notifySuccess('Session resumed');
    })
    .catch(err => {
      console.log(err);
      notifyError('Failed to resume session');
    });
};

// Coach-only: cancels a scheduled session. Clears any pending reminder
// tasks, deletes the coach's pushed calendar event (if connected), and
// emails the client a cancellation notice with a reschedule link — all
// server-side (see coach-saas-service activityAccess.cancelSession).
export const cancelSession = (activityId, sessId) => async (dispatch, getState, sdk) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/cancel`,
      {},
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      notifySuccess('Session cancelled');
      return res;
    })
    .catch(err => {
      console.log(err);
      const code = err.response && err.response.data && err.response.data.code;
      const message =
        code === 'not_cancellable'
          ? 'This session can no longer be cancelled'
          : 'Could not cancel the session — please try again';
      notifyError(message);
      throw err;
    });
};

export const makeSessionClose = (activityId, sessId, closedTime) => async (
  dispatch,
  getState,
  sdk
) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/close`,
      { closedTime },
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      notifySuccess('Session closed');
    })
    .catch(err => {
      console.log(err);
      notifyError('Failed to close session');
    });
};

export const SendSummaryPending = (activityId, sessId) => async (dispatch, getState, sdk) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/sendsummarypending`,
      {},
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      // DEBUG (send-summary-email investigation): a 200 here only means the
      // Firestore status update succeeded — sendPendingSummary's Mautic
      // send is wrapped in its own try/catch server-side and fails silently
      // from this caller's point of view, so a 200 does NOT guarantee the
      // email actually went out. Check the backend's [send-summary] logs
      // for the real outcome. Remove once the missing-email bug is found.
      console.log('[send-summary] sendsummarypending HTTP 200', res && res.data);
      notifySuccess('Congratulations You have successfully completed the Session');
    })
    .catch(err => {
      console.log('[send-summary] sendsummarypending HTTP error', {
        status: err && err.response && err.response.status,
        data: err && err.response && err.response.data,
        message: err && err.message,
      });
      notifyError('Failed to complete session — please try again');
    });
};

export const sendEmailToClient = (activityId, sessId) => async (dispatch, getState, sdk) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/sendclientmail`,
      {},
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      notifySuccess('Email sent to client');
    })
    .catch(err => {
      console.log(err);
      notifyError('Failed to send email — please try again');
    });
};

export const saveSessionNotes = (activityId, sessId, notes) => async (dispatch, getState, sdk) => {
  return axios
    .post(
      `${config.coachSaaSService}activities/${activityId}/session/${sessId}/save`,
      { notes: notes },
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      notifySuccess('Session notes saved');
    })
    .catch(err => {
      console.log(err);
      notifyError('Saving failed — please try again');
    });
};

export const getMyEvents = () => async (dispatch, getState, sdk) => {
  dispatch(eventsRequest());
  return axios
    .post(
      `${config.coachSaaSService}activities/getMyEvents`,
      {},
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    )
    .then(res => {
      dispatch(eventsSuccess(res.data));
    })
    .catch(err => {
      console.log(err);
      dispatch(eventsError(err));
    });
};

export const createCustomClientActivity = (customerId, programId) => async (
  dispatch,
  getState,
  sdk
) => {
  return axios.post(
    `${config.coachSaaSService}activities/add_custom_client_activity`,
    {
      customer_id: customerId,
      program_id: programId,
    },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

export const createFreeCallActivity = listingId => async (dispatch, getState, sdk) => {
  // return new Promise((resolve, reject) => setTimeout(() => resolve({ data: { id: '123' } }), 1000));
  return axios.post(
    `${config.coachSaaSService}activities/request_free_call`,
    {
      listingId: listingId,
    },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

export const getPendingSurveys = () => async (dispatch, getState, sdk) => {
  dispatch(surveysRequest());
  return axios
    .get(`${config.coachSaaSService}survey/get-all`, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    })
    .then(res => {
      console.log('🚀 ~ getPendingSurveys ~ res:', res);
      // Filter for active surveys only
      const activeSurveys = Array.isArray(res.data)
        ? res.data.filter(survey => survey.isActive === true)
        : [];

      dispatch(surveysSuccess(activeSurveys));
      return activeSurveys;
    })
    .catch(err => {
      console.log('Error fetching surveys:', err);
      dispatch(surveysError(err));
      throw err;
    });
};
